import React, { useState, useEffect } from 'react';
import {
  Box, Button, Input, VStack, Heading, useToast, Text
} from '@chakra-ui/react';
import { useAuthCliente } from '../context/AuthClienteContext';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase/firebase-config';
import { doc, getDoc } from 'firebase/firestore';
import Lottie from 'lottie-react';
import SplashAnimation from '../assets/splash.json';
import LoginSuccessAnimation from '../components/LoginSuccessAnimation';


export default function LoginPage() {
  const { login, currentUser } = useAuthCliente();
  const toast = useToast();
  const navigate = useNavigate();

  const [loginForm, setLoginForm] = useState({
    email: '',
    password: ''
  });

  const [loadingLogin, setLoadingLogin] = useState(false);

  useEffect(() => {
    if (currentUser) {
      navigate('/portal/inicio');
    }
  }, [currentUser, navigate]);

  const handleLoginChange = (e) => {
    setLoginForm({ ...loginForm, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setLoadingLogin(true);
    try {
      let companyId = localStorage.getItem('activeCompanyId');

      if (!companyId) {
        const directoryRef = doc(db, 'user_directory', loginForm.email);
        const directorySnap = await getDoc(directoryRef);
        if (directorySnap.exists()) {
          companyId = directorySnap.data().companyId;
          localStorage.setItem('activeCompanyId', companyId);
        } else {
          throw new Error('No se encontró un club activo. Por favor accedé desde una invitación válida.');
        }
      }

      await login(loginForm.email, loginForm.password, companyId);

    } catch (err) {
      toast({
        title: 'Error al iniciar sesión',
        description: err.message || 'Credenciales incorrectas.',
        status: 'error',
        duration: 5000,
        isClosable: true,
        position: 'top'
      });
    } finally {
      setLoadingLogin(false);
    }
  };

  return (
    <Box minH="100vh" display="flex" alignItems="center" justifyContent="center" bg="2" px={4} pt={60} position="relative">
     <Box position="absolute" top="10%" left="32%" zIndex={0}>
  <Lottie animationData={SplashAnimation} loop autoplay style={{ width: '35vw', height: '35vh' }} />
</Box>

      <VStack spacing={6} w="full" maxW="md" bg="white" p={8} borderRadius="md" boxShadow="lg" zIndex={1}>
        <Heading size="lg" textAlign="center">Iniciar Sesión</Heading>

        <VStack spacing={3} w="full">
          <Input
            name="email"
            placeholder="Correo electrónico"
            type="email"
            value={loginForm.email}
            onChange={handleLoginChange}
          />
          <Input
            name="password"
            placeholder="Contraseña"
            type="password"
            value={loginForm.password}
            onChange={handleLoginChange}
          />
          <Button
            colorScheme="green"
            w="full"
            onClick={handleLogin}
            isLoading={loadingLogin}
            loadingText="Iniciando..."
          >
            Iniciar Sesión
          </Button>
        </VStack>

        <Text fontSize="sm" color="gray.500">
          ¿No tenés cuenta? <b><a href="/registro">Creá una aquí</a></b>
        </Text>
      </VStack>
    </Box>
  );
}